import React, { useEffect } from 'react';
import './css/App.scss';
import * as FIUser from './data/FIUser.js'; //NEEDED
import * as FISponsor from './data/FISponsor.js'; //NEEDED no matter what the react warning says
import { BrowserRouter, Route, Switch, Redirect} from "react-router-dom";
import Home from './views/home.js';
import Users from './views/users.js';
import Goals from './views/goals.js';
import Login from './views/login.js';
import StrategicGoals from './views/strategicgoals.js';
import Recommendations from './views/recommendations.js';
import BuildSkills from './views/buildskills.js';
import Settings from './views/settings.js';
import PassReset from './views/resetpassword.js';
import AppConfiguration from './views/appconfiguration.js';

var app = {
  version: '1.7.8',
  page_finished: false
};

app.apiurl = (app.version.indexOf('dev') > -1 || app.version.indexOf('demo') > -1) ? 'https://phobos.plinqit.com/' : 'https://api.plinqit.com/'; 
app.ssourl = (app.version.indexOf('dev') > -1 || app.version.indexOf('demo') > -1) ? 'https://signon.plinqit.com/login/' : '';
app.supporturl = 'https://support.plinqit.com';

window.app = app;

function Logout ({match}) {
  window._fiUser.deleteSessionInfo();
  window._fiSponsor.deleteSessionInfo();
  return (
    <div><p>You are Logged Out</p></div>
    );
}

function App() {

  useEffect(() => {
        const interval = setInterval(() => {
          if(window._fiUser.token.length && window.location.pathname.length > 1) window._fiUser.CHECK_TOKEN();
        }, 30000);
        return () => clearInterval(interval);
      }, []);

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Login} />
        <Route path="/Home" exact component={Home} />
        <Route path="/Users" exact component={Users} />
        <Route path="/Goals" exact component={Goals} />
        <Route path="/BuildSkills" exact component={BuildSkills} />
        <Route path="/StrategicGoals" exact component={StrategicGoals} />
        <Route path="/Recommendations" exact component={Recommendations} />
        <Route path="/AppConfiguration" exact component={AppConfiguration} />
        <Route path="/Settings" exact component={Settings} />
        <Route path="/Logout" exact component={Logout} />
        <Route path="/PassReset" exact component={PassReset} />
      </Switch>
    </BrowserRouter>
    );
}

export default App;
